import { loader } from 'graphql.macro'

export default function sites ({ dataLoaders, queryKey }) {
  const [, haulerId] = queryKey
  const schema = loader('./sites.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(schema, { haulerId })
}
